'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.sendRequest = sendRequest;

var _promise = require('./promise');

var _url = require('./url');

// if you change anything here, please also update copy in wix-music-widget src/scripts/utils/send-request.js
function sendRequest(options) {
  options = _extends({
    method: 'GET',
    type: 'json',
    withCredentials: false
  }, options);

  if (!options.url) {
    throw new TypeError('url is not specified');
  }

  if (options.type === 'json') {
    options = withJsonDefaults(options);
  }

  var _options = options,
      method = _options.method,
      url = _options.url,
      data = _options.data,
      params = _options.params,
      headers = _options.headers;

  var parametrizedUrl = createParametrizeUrl(url, params);

  var requestPromise = new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.addEventListener('load', function () {
      var response = { status: request.status, text: request.responseText };
      try {
        response.data = parseResponseBody(request);
      } catch (reason) {
        reject(reason);
      }
      if (request.status < 200 || request.status > 299) {
        reject(response);
        return;
      }
      resolve(response);
    });

    function onError(status, text) {
      return function () {
        reject({ status: status, text: text });
      };
    }

    request.addEventListener('error', onError(-100, 'error'));
    request.addEventListener('abort', onError(-200, 'aborted'));

    request.open(method, parametrizedUrl, true);
    request.withCredentials = options.withCredentials;
    Object.keys(headers).forEach(function (header) {
      request.setRequestHeader(header, headers[header]);
    });
    request.send(data);
  });
  if (options.timeout) {
    return (0, _promise.addTimeout)(requestPromise, { time: options.timeout, reason: 'RequestTimeout' });
  }
  return requestPromise;
}

function withJsonDefaults(options) {
  function getHeaders() {
    var headers = {
      Accept: 'application/json'
    };
    if (options.method === 'POST') {
      headers['Content-Type'] = 'application/json; charset=utf-8';
    }
    return _extends({}, headers, options.headers);
  }

  function getData() {
    var data = options.data;
    return data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? JSON.stringify(data) : data;
  }

  return _extends({}, options, {
    headers: getHeaders(),
    data: getData()
  });
}

function createParametrizeUrl(url, params) {
  if (!params || !Object.keys(params).length) {
    return url;
  }

  if (url.indexOf('?') !== -1) {
    throw new TypeError('Adding param to urls with params is not supported');
  }
  var stringifiedParams = (0, _url.createParam)(params);
  return url + '?' + stringifiedParams;
}

function parseResponseBody(request) {
  var contentType = request.getResponseHeader('Content-Type');
  if (contentType && contentType.indexOf('application/json') === 0) {
    try {
      return JSON.parse(request.responseText);
    } catch (ex) {
      throw new Error('Cannot parse response body');
    }
  }
  return request.responseText;
}
//# sourceMappingURL=send-request.js.map



//////////////////
// WEBPACK FOOTER
// ../~/music-shared/dist/src/utils/send-request.js
// module id = 20
// module chunks = 9 10